import checkSchema from './check_schema';
import cancelBookingModalFormTemplate from './cancel_booking_modal_form.html';

function EditFormCtrl($scope, $uibModal, $uibModalInstance, model, title, successFn, failFn, params, $log, FormTransform,
                      $translate, bbTimeZone, dialog, enforceTimeZoneFn, determineTimeZoneFn, onDismissFn) {
    'ngInject';

    if (enforceTimeZoneFn) {
        if (model.company_time_zone) {
            enforceTimeZoneFn(model.company_time_zone);
            initialise();
        } else {
            model.$get('company').then((company) => {
                enforceTimeZoneFn(company.timezone);
                initialise();
            });
        }
    } else {
        initialise();
    }


    function initialise() {
        $scope.loading = true;
        $scope.title = title;
        $scope.model = model;
        if (!params) {
            params = {};
        }
        if ($scope.model.$has('edit')) {
            $scope.model.$get('edit', params).then((schema) => {
                    $scope.form = _.reject(schema.form, x => x.type === 'submit');
                    $scope.schema = checkSchema(schema.schema);
                    let model_type = functionName(model.constructor);
                    if (model_type === 'Object' && model.type) {
                        model_type = model.type;
                    }
                    if (FormTransform['edit'][model_type]) {
                        const modified = FormTransform['edit'][model_type]($scope.form, $scope.schema, $scope.model);
                        if (angular.isArray(modified)) {
                            $scope.form = modified;
                        } else {
                            $scope.form = modified.form;
                            $scope.schema = modified.schema;
                        }
                    }
                    $scope.form_model = $scope.model;
                    return $scope.loading = false;
                }
            );
        } else {
            $log.warn('model does not have \'edit\' rel');
        }

        $scope.$on('modal.closing', () => {
            if (determineTimeZoneFn) determineTimeZoneFn();
        });
    }

    const functionName = function (func) {
        const result = /^function\s+([\w\$]+)\s*\(/.exec(func.toString());
        if (result) {
            return result[1];
        } else {
            return '';
        }
    };

    $scope.submit = function (form, updateDatetime) {
        $scope.$broadcast('schemaFormValidate');
        $scope.loading = true;

        if ($scope.model.$update) {

            // Ensure from_datetime is saved when editing a block time
            if (updateDatetime) {
                $scope.form_model.datetime = $scope.form_model.from_datetime;
            }

            $scope.form_model.datetime = bbTimeZone.convertToCompany($scope.form_model.datetime);


            $scope.model.$update($scope.form_model).then(() => {

                    $scope.loading = false;
                    $uibModalInstance.close($scope.model);
                    if (successFn) {
                        return successFn($scope.model);
                    }
                }
                , (err) => {
                    $scope.loading = false;

                    $log.error('Failed to create');
                    if (failFn) {
                        return failFn();
                    }
                });
        } else {
            return $scope.model.$put('self', {}, $scope.form_model).then((model) => {
                    $scope.loading = false;
                    $uibModalInstance.close(model);
                    if (successFn) {
                        return successFn(model);
                    }
                }
                , (err) => {
                    $scope.loading = false;

                    $log.error('Failed to create');
                    if (failFn) {
                        return failFn();
                    }
                });
        }
    };

    $scope.cancel = function (event, dismiss_reason = 'cancel') {
        event.preventDefault();
        event.stopPropagation();
        return $uibModalInstance.dismiss(dismiss_reason);
    };

    $scope.success = function (response) {
        event.preventDefault();
        event.stopPropagation();
        $uibModalInstance.close();
        if (successFn) {
            return successFn(response);
        }
    };

    $uibModalInstance.result
        .then((response) => {
            if (response) return;

            if (onDismissFn) onDismissFn();
        })
        .catch((error) => {
            if (onDismissFn) onDismissFn();
        });

    $scope.cancelEvent = function (event, type) {
        if (type == null) {
            type = 'booking';
        }
        event.preventDefault();
        event.stopPropagation();
        $uibModalInstance.close();
        if (type === 'booking') {
            const modal_instance = $uibModal.open({
                keyboard: false,
                templateUrl: cancelBookingModalFormTemplate.id,
                controller($scope, booking) {
                    $scope.booking = booking;
                    return $scope.model = {
                        notify: false,
                        cancel_reason: null
                    };
                },
                resolve: {
                    booking() {
                        return model;
                    }
                }
            });
            return modal_instance.result.then(params =>
                model.$post('cancel', params).then((booking) => {
                    if (successFn) {
                        return successFn(booking);
                    }
                })
            );
        } else {
            return dialog.confirm({
                title: $translate.instant('CORE.MODAL.CANCEL_BOOKING.HEADER'),
                body: $translate.instant('CORE.MODAL.CANCEL_BOOKING.QUESTION', {type}),
                keyboard: false
            })
                .then(() => model.$del('self'))
                .then((response) => {
                    if (successFn) {
                        return successFn(response);
                    }
                });
        }
    };
}

export default EditFormCtrl;



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/modal_form/edit_form.controller.js